import { render, staticRenderFns } from "./CreateGalleryPopup.vue?vue&type=template&id=6479cd08&scoped=true&"
import script from "./CreateGalleryPopup.vue?vue&type=script&lang=js&"
export * from "./CreateGalleryPopup.vue?vue&type=script&lang=js&"
import style0 from "./CreateGalleryPopup.vue?vue&type=style&index=0&id=6479cd08&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6479cd08",
  null
  
)

export default component.exports